export default function Logo({ variant = "dark", testId = "nav-logo" }) {
  const isLight = variant === "light";
  return (
    <span
      className={`inline-flex items-center select-none ${isLight ? "bg-white rounded-lg px-2.5 py-2" : ""}`}
      data-testid={testId}
    >
      <img
        src="/logo-iprs.png"
        alt="IPRS Soluções em TI"
        width={118}
        height={80}
        className="h-10 w-auto sm:h-11"
      />
    </span>
  );
}
